import { useEffect, useState } from "react";
import { Check, Pencil } from "lucide-react";

export function WritingPanel({ room, send }) {
  const [text, setText] = useState("");
  const [editing, setEditing] = useState(true);
  const online = room.players.filter((p) => p.connected).length;
  const mine = room.my_submission;

  useEffect(() => {
    setText("");
    setEditing(true);
  }, [room.round]);

  const submit = () => {
    if (!text.trim()) return;
    send("submit", { text });
    setEditing(false);
  };

  if (mine && !editing) {
    return (
      <div className="patch p-5 sm:p-7 space-y-4" data-testid="writing-submitted">
        <div className="flex items-center gap-2 text-[var(--yarn-sage)] font-display"><Check size={18} /> Your line is in</div>
        <p className="font-story text-lg italic" data-testid="my-submission-text">"{mine}"</p>
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm text-[var(--yarn-muted)]" data-testid="submission-progress">{room.submission_count} of {online} lines in</p>
          <button className="btn-soft h-10 px-4 text-sm inline-flex items-center gap-1" onClick={() => { setText(mine); setEditing(true); }} data-testid="edit-submission-button">
            <Pencil size={14} /> Change it
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="patch p-5 sm:p-7 space-y-3" data-testid="writing-panel">
      <label htmlFor="line-input" className="font-display text-sm font-medium">What happens next?</label>
      <textarea id="line-input" value={text} maxLength={280} rows={3} autoFocus
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } }}
        placeholder="Add one sentence to the story..."
        className="field w-full p-4 font-story text-lg resize-none" data-testid="submit-sentence-input" />
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs text-[var(--yarn-muted)]" data-testid="char-counter">{text.length}/280 · {room.submission_count} of {online} in</p>
        <button className="btn-yarn h-12 px-7" disabled={!text.trim()} onClick={submit} data-testid="submit-sentence-button">
          Add my line
        </button>
      </div>
    </div>
  );
}
